import { set } from 'lodash';
import React, { createContext, useState, useEffect } from 'react';
import { io } from 'socket.io-client';
import { API } from '../config/api';

export const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const [machineData, setMachineData] = useState({
    state: [],
    currentShift: null
  });
  const [machineSingle, setMachineSingle] = useState(null);
  const [orders, setOrders] = useState([]);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    console.log('Connecting to WebSocket server...');

    const newSocket = io(API.WS, {
      transports: ['websocket'], // forțăm websocket (nu long-polling)
      // :8080 authenticates the handshake now. On the factory network a client
      // without a token is still allowed, so this changes nothing on the LAN —
      // it is what makes the connection work from OUTSIDE, through the tunnel.
      auth: { token: localStorage.getItem('token') || '' }
    });

    newSocket.on('connect', () => console.log('✅ Socket.IO connected'));
    newSocket.on('disconnect', () => console.log('❌ Socket.IO disconnected'));

    // ascultăm update-urile de la backend
    newSocket.on('machineAllSnapshot', state => {
      console.log('Received machineAllSnapshot:', state);

      setMachineData(state);
    });
    newSocket.on('machineAllUpdate', state => {
      console.log('Received machineAllUpdate:');
      console.log(state);
      setMachineData(state);
    });

    newSocket.on('machineSingleSnapshot', state => {
      console.log('Received machineSingleSnapshot:');
      setMachineSingle(state);
    });

    newSocket.on('machineSingleUpdate', state => {
      console.log('Received machineSingleUpdate:');
      setMachineSingle(state);
    });

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, []);

  const subscribeToChannel = (channelType, machineId = null) => {
    if (socket) {
      console.log(
        'SUBSCRIBING to channel:',
        channelType,
        'for machineId:',
        machineId
      );
      socket.emit('subscribe', { channelType, machineId });
    }
  };

  const unsubscribeToChannel = () => {
    if (socket) {
      socket.emit('unsubscribe');
    }
  };

  return (
    <WebSocketContext.Provider
      value={{
        socket,
        machineData,
        machineSingle,
        orders,
        subscribeToChannel,
        unsubscribeToChannel
      }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};
